export default {
  partyId: (state) => state.userSession?.currentBu?.id || state.userSession?.buList?.[0]?.id,
  isStore: (state) => state.currentShop?.shopType === 'STORE',
  isRent: (state) => state.userSession?.trade === 'RENT',
}
